import styled from "styled-components";
export const StyledTable = styled.div`
  td.ant-table-row-expand-icon-cell {
    text-overflow: inherit;
  }
`;
